import React, { useEffect, useState } from "react";
import { Flex,Box,Button, Table, Tbody, Text, Th, Td, Thead, Tr, IconButton, useColorModeValue, Badge } from "@chakra-ui/react";
import { EditIcon, DeleteIcon } from "@chakra-ui/icons";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import { useHistory } from "react-router-dom";
import { SearchBar } from "components/Input/SearchBar";
import OrderApi from "../../api/order";
import { convertToJalali } from "utils/helper";
import Pagination from "components/Pagination/Pagination";

function Orders() {
  const [orders, setOrders] = useState([]);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const textColor = useColorModeValue("gray.700", "white");
  const history = useHistory();

  useEffect(() => {
    fetchOrders(currentPage);
  }, [search, currentPage]);

  const fetchOrders = async (page = 1) => {
    try {
      const response = await OrderApi.Get(search, page);
      setOrders(response.data.data);
      setTotalPages(response.data.meta.last_page);
    } catch (err) {
      console.error("Error fetching orders:", err);
    }
  };

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
    setCurrentPage(1); // Reset page to 1 on search change
  };

  const handleViewDetails = (orderId) => {
    history.push(`/admin/orders/${orderId}`);
  };

  const handleEdit = (orderId) => {
    console.log("Edit order with id:", orderId);
  };

  const handleDelete = (orderId) => {
    console.log("Delete order with id:", orderId);
  };

  return (
    <Flex direction="column" pt={{ base: "120px", md: "75px" }}>
      <Card overflowX={{ sm: "scroll", xl: "hidden" }}>
        <CardHeader p="6px 0px 22px 0px" display="flex" alignItems="center" justifyContent="space-between">
          <Text fontSize="xl" color={textColor} fontWeight="bold">
            جدول سفارشات
          </Text>
          <SearchBar value={search} onChange={handleSearchChange} />
        </CardHeader>
        <CardBody>
          <Table variant="simple" color={textColor}>
            <Thead>
              <Tr my=".8rem" pl="0px" color="gray.400">
                <Th color="gray.400">آیدی سفارش</Th>
                <Th pl="0px" color="gray.400" width="20%">نام/شماره سفارش</Th>
                <Th color="gray.400">تاریخ</Th>
                <Th color="gray.400">وضعیت</Th>
                <Th></Th>
              </Tr>
            </Thead>
            <Tbody>
              {orders.map((order) => (
                <Tr key={order.id}>
                  <Td>{order.id}</Td>
                  <Td>{order.worder_id}</Td>
                  <Td>{convertToJalali(order.created_at)}</Td>
                  <Td>
                    {order.status.id === 2 ? (
                       <Badge
                       colorScheme="red"
                       variant="solid"
                       fontSize="md"
                       p={2}
                       borderRadius="md"
                     >
                      نیاز به تغییرات
                     </Badge>
                    ) : (
                      <Badge
                        colorScheme="green"
                        variant="solid"
                        fontSize="md"
                        p={2}
                        borderRadius="md"
                      >
                        تکمیل
                      </Badge>
                    )}
                  </Td>
                  <Td textAlign="center">
                    <Button
                      size="sm"
                      colorScheme="teal"
                      bg="teal.500"
                      color="white"
                      mr={2}
                      onClick={() => handleViewDetails(order.id)}
                    >
                      جزئیات
                    </Button>
                    <IconButton
                      size="sm"
                      colorScheme="blue"
                      aria-label="Edit"
                      icon={<EditIcon />}
                      onClick={() => handleEdit(order.id)}
                      mr={1}
                    />
                    <IconButton
                      size="sm"
                      colorScheme="red"
                      aria-label="Delete"
                      icon={<DeleteIcon />}
                      onClick={() => handleDelete(order.id)}
                      mr={1}
                    />
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </CardBody>
      </Card>
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={setCurrentPage}
      />
    </Flex>
  );
}

export default Orders;
